import React, { useState } from 'react';
import { Popup } from 'controls';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import './_Input.scss';
import 'styles/_form.scss';

export const Input = ({
  name, field, classes, placeholder, style, type, label, isPassword, disable,
}) => {
  const [newType, setType] = useState(type);
  const isPlugin = window.location.pathname === '/auth/plugin';
  const showPassword = () => {
    if (newType === 'password') {
      setType('text');
    } else {
      setType('password');
    }
  };
  return (
    <>
      <Popup
        message={field.message}
        enabled={field.errored}
      >
        <input
          name={name}
          value={field.value}
          readOnly={disable}
          onChange={!disable ? field.onChange : undefined}
          className={`${classes} ${field.errored ? 'input-err' : ''}  ${disable ? 'input-disable' : ''}`}
          placeholder={!placeholder && !label && name ? name : placeholder}
          style={style}
          type={!newType ? 'text' : newType}
        />
      </Popup>
      {isPassword
        && (
          <Icon
            className={`${isPlugin ? 'input__plugin-icon' : 'input-icon'} ${newType === 'text' && 'input-icon__select'}`}
            name='eye'
            onClick={showPassword}
          />
        )}
    </>
  );
};
Input.propTypes = {
  name: PropTypes.string,
  field: PropTypes.object,
  classes: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  type: PropTypes.string,
  label: PropTypes.bool,
  isPassword: PropTypes.bool,
  disable: PropTypes.bool,
};
